import React, { Fragment } from 'react';
import useTranslations from '@/hooks/translations';
import useBrowserHistory from '../../../hooks/browserHistory';
import LoginCard from '../../login/clean';
import Header from '../Header';
import styles from './styles';
import Text from '../../app/Text';

export default function Signup({
  onNext,
  onBack,
  disableLogin,
  isCoachingOnboarding,
  experiments,
  profile,
  isMergeYourPlanWithSignUpScr,
  hide,
  user: userData,
}) {
  useBrowserHistory('signup', true, onBack, onNext);
  const { t } = useTranslations();
  const user = userData || profile;
  return (
    <Fragment>
      <div className="item-container">
        <Header
          isCoaching={!!isCoachingOnboarding}
          subtitleColor="g50"
          title={
            typeof user.personalizePlan !== 'undefined' && !user.personalizePlan
              ? t('onboarding_signup_form_save_progess_exp')
              : t('onboarding_signup_form_save_progess')
          }
          center={true}
          experiments={experiments}
          isMergeYourPlanWithSignUpScr={isMergeYourPlanWithSignUpScr}
        />
        {experiments.mergeYourPlanWithSignUpScr !== 'a' && (
          <Text
            type="body2"
            color="b100"
            style={{ marginTop: 12, fontSize: '15px' }}>
            {t('onboarding_signup_form_3_steps')}
          </Text>
        )}

        <LoginCard
          onSubmit={({ givenName }) => {
            onNext({ givenName });
          }}
          buttonText={t('onboarding_signup_form_button_text_see_my_plan')}
          disableLogin={disableLogin}
          showGoogleLogin={false}
          hideCard={true}
          style={{
            marginTop: 24,
            minWidth: isMergeYourPlanWithSignUpScr && 0,
          }}
          disableSocial={true}
          experiments={experiments}
          profile={profile}
          isMergeYourPlanWithSignUpScr={
            isMergeYourPlanWithSignUpScr && !isCoachingOnboarding
          }
          hide={hide}
          user={user}
        />
      </div>
      <style jsx>{styles}</style>
    </Fragment>
  );
}
